/*
 * Copyright (c) 2016-2018 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
export const CLR_MENU_POSITIONS: string[] = [
  'bottom-left',
  'bottom-right',
  'top-left',
  'top-right',
  'left-bottom',
  'left-top',
  'right-bottom',
  'right-top',
];
